import React from 'react';
import { CTAButton } from './CTAButton';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-900 px-4 pb-32 pt-12 sm:px-6" data-id="element-149" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-2xl text-center" data-id="element-150" data-mp="32nun0sijob3h">
        <p className="font-display text-2xl font-700 uppercase tracking-[0.3em] text-gold-400" data-id="element-151" data-mp="32pfeuadh5fxn">
          Dr. Karito
        </p>
        <p className="mt-2 text-sm text-slate-300" data-id="element-152" data-mp="36n3cvmagrotr">
          DVO Master Protocol™ · Clinical Educational Material
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-153" data-mp="39922nzchmct">
          <CTAButton label="Get instant access — $27" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-154" data-mp="37xx4ku5y8k4" />
        </div>

        <p className="mt-9 text-xs leading-relaxed text-slate-400" data-id="element-155" data-mp="3qcdsl0a7m9rv">
          This product is educational material and does not replace professional diagnosis, clinical
          judgment, professional training, or individualized patient care. Application of the
          information is the responsibility of the individual dental professional.
        </p>
        <p className="mt-4 text-xs text-slate-500" data-id="element-156" data-mp="3lbdb8osqm1jp">© 2026 Dr. Karito. All rights reserved.</p>
      </div>
    </footer>;
}